import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {Home, Business, FilterDrama, SettingsRemote} from "@material-ui/icons";
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import HomeIt from "./HomeIT";
import BusinessIT from "./BusinessIT";
import CloudIT from './CloudIT';
import RemoteSupport from './RemoteSupport';

function TabPanel(props) {
  const {children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-prevent-tabpanel-${index}`}
      aria-labelledby={`scrollable-prevent-tab-${index}`}
      {...other}
    >
      <Box p={3}>
        <Typography component="div">{children}</Typography>
      </Box>
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-prevent-tab-${index}`,
    'aria-controls': `scrollable-prevent-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    maxWidth: '1100px',
    margin: '0 auto'
  },
  tabsContainer: {
    background: '#ffffff',
    borderRadius: '20px',
    boxShadow: '0 8px 40px rgba(23, 57, 98, 0.1)',
    overflow: 'hidden',
    marginBottom: '24px'
  },
  tabs: {
    background: 'linear-gradient(135deg, #173962 0%, #1d5482 100%)',
    '& .MuiTab-root': {
      color: 'rgba(255, 255, 255, 0.7)',
      fontFamily: "'Chivo', sans-serif",
      fontWeight: 500,
      transition: 'all 0.3s ease',
      '&:hover': {
        color: '#ffffff',
        background: 'rgba(255, 255, 255, 0.1)'
      }
    },
    '& .Mui-selected': {
      color: '#ffffff !important',
      background: 'rgba(255, 255, 255, 0.15)'
    },
    '& .MuiTabs-indicator': {
      backgroundColor: '#1DAEE0',
      height: '4px',
      borderRadius: '4px 4px 0 0'
    }
  },
  tabPanel: {
    background: '#ffffff',
    borderRadius: '0 0 20px 20px'
  }
}));

export default function ScrollableTabsButtonPrevent() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const sectionStyle = {
    paddingTop: "100px",
    paddingBottom: "80px",
    background: "linear-gradient(135deg, #f8f9fa 0%, #e8f4f8 100%)"
  };

  const headingStyle = {
    fontFamily: "'Century Gothic', -apple-system, sans-serif",
    fontSize: "clamp(2rem, 5vw, 2.75rem)",
    fontWeight: "700",
    background: "linear-gradient(135deg, #173962 0%, #1DAEE0 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    marginBottom: "40px",
    textAlign: "center"
  };

  const tabStyle = {
    minHeight: "100px",
    fontSize: "1rem",
    fontWeight: 600,
    textTransform: "none",
    padding: "20px 16px"
  };

  return (
    <div id="ITTABS" className="jumbotron jumbotron-fluid min-vh-auto m-0" style={sectionStyle}>
      <div className="container container-fluid p-4">
        <div className={classes.root}>
          <h1 style={headingStyle}>Our Services</h1>

          <div className={classes.tabsContainer}>
            <Tabs
              value={value}
              onChange={handleChange}
              variant="fullWidth"
              scrollButtons="off"
              aria-label="IT services tabs"
              className={classes.tabs}
            >
              <Tab style={tabStyle} label="Home" icon={<Home style={{fontSize: 32}} />} {...a11yProps(0)} />
              <Tab style={tabStyle} label="Business" icon={<Business style={{fontSize: 32}} />} {...a11yProps(1)} />
              <Tab style={tabStyle} label="Cloud & Web" icon={<FilterDrama style={{fontSize: 32}} />} {...a11yProps(2)} />
              <Tab style={tabStyle} label="Remote Support" icon={<SettingsRemote style={{fontSize: 32}} />} {...a11yProps(3)} />
            </Tabs>

            <TabPanel className={classes.tabPanel} value={value} index={0}>
              <HomeIt/>
            </TabPanel>
            <TabPanel className={classes.tabPanel} value={value} index={1}>
              <BusinessIT/>
            </TabPanel>
            <TabPanel className={classes.tabPanel} value={value} index={2}>
              <CloudIT/>
            </TabPanel>
            <TabPanel className={classes.tabPanel} value={value} index={3}>
              <RemoteSupport/>
            </TabPanel>
          </div>
        </div>
      </div>
    </div>
  );
}
